import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { Globalloader } from "components/preview";
import config from "utilities/config";
import { PopupBuilder } from "components/preview/PopupBuilder";

// Disable alert() execution from console
window.alert = function() {
  console.warn("alert() has been disabled for security reasons");
};

// Set dynamic title
if (!config || !config.TITLE) {
  console.error("Error: Configuration is missing or invalid");
} else {
  document.title = config.TITLE;
}

// Optional Error Boundary (for safety)
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }
  render() {
    if (this.state.hasError) {
      // Reload only once
      setTimeout(() => window.location.reload(), 100);
      return null;
    }
    return this.props.children;
  }

}

const app = (
  <Provider store={store}>
    <PopupBuilder>
      <Globalloader />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PopupBuilder>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  process.env.REACT_APP_ENV !== "prod" && process.env.REACT_APP_ENV !== "uat" ? (
    <React.StrictMode>{app}</React.StrictMode>
  ) : (
    app
  )
);

// ✅ Auto reload on chunk error
window.addEventListener("error", (event) => {
  if (event?.message?.includes("Loading chunk")) {
    window.location.reload();
  }
});

// ✅ Unregister any service workers
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}


reportWebVitals();



